import { HelpService } from '../../shared/services/helpservice/help.service';
import { UploaddocumentService } from '../../shared/services/uploaddocument/uploaddocument.service';
import { FormGroup } from '@angular/forms';
import { NewRegistrationDataCollectionService } from 'src/app/shared/services/registration/newRegistration-data-collection.service';
import { RegistrationModel } from '../models/data/registration.model';

export class NewRegistrationsDetailsUpdate {

    dataCollectionSvc: NewRegistrationDataCollectionService;
    helpService: HelpService;
    uploaddocumentService: UploaddocumentService;

    constructor(
        dataCollectionSvc: NewRegistrationDataCollectionService,
        helpService: HelpService,
        uploaddocumentService?: UploaddocumentService) {
        this.dataCollectionSvc = dataCollectionSvc;
        this.uploaddocumentService = uploaddocumentService;
    }

    // modelChange(dataModel: Registration, event, target?: string) {
    //     if (target && target !== undefined) {
    //         dataModel = this.cleanData(dataModel, target);
    //     }
    //     // this.dataCollectionSvc.sync(dataModel, '');
    // }
    syncModelChange(reg: RegistrationModel) {
        this.dataCollectionSvc.sync(reg, null);
    }

    modelChangeTenant(dataModel: RegistrationModel) {
        this.dataCollectionSvc.sync(dataModel, null);
    }

    helpField(field) {
        this.helpService.showHelpForField(field);
    }
    // clearing values based on dropdown selection change
    clearBuildingControls(buildingInfoForm: FormGroup) {
        if (!buildingInfoForm.get('reasons').value.includes('Other')
        && buildingInfoForm.get('otherReasonText').value !== null) {
            buildingInfoForm.get('otherReasonText').setValue(null);
        }

        if (!buildingInfoForm.get('reasons').value.includes('Section421a16')) {
            if (!buildingInfoForm.get('reasons').value.includes('Section421a15')
                && buildingInfoForm.get('marketRate').value !== null) {
                buildingInfoForm.get('marketRate').setValue(null);
            }
            if (!buildingInfoForm.get('reasons').value.includes('Section421a15')
                && buildingInfoForm.get('incomeRestricted').value !== null) {
                buildingInfoForm.get('incomeRestricted').setValue(null);
            }
        }

        if (buildingInfoForm.get('buildingDescription').value !== 'CoopCondo') {
            if (buildingInfoForm.get('evictionDate').value !== null) {
                buildingInfoForm.get('evictionDate').setValue(null);
            }
            if (buildingInfoForm.get('filedDate').value !== null) {
                buildingInfoForm.get('filedDate').setValue(null);
            }
            if (buildingInfoForm.get('nonEvictionDate').value !== null) {
                buildingInfoForm.get('nonEvictionDate').setValue(null);
            }
            if (buildingInfoForm.get('associationName').value !== null) {
                buildingInfoForm.get('associationName').setValue(null);
            }
        }
        if (!buildingInfoForm.get('reasons').value.includes('Section421a15')) {
            if (!buildingInfoForm.get('reasons').value.includes('RegulatoryAgreement')
                && buildingInfoForm.get('regulatoryAgreementText').value !== null) {
                buildingInfoForm.get('regulatoryAgreementText').setValue(null);
            }
            if (buildingInfoForm.get('hpdRentAmount').value !== null) {
                buildingInfoForm.get('hpdRentAmount').setValue(null);
            }
            if (!buildingInfoForm.get('reasons').value.includes('Section421a16')
                && buildingInfoForm.get('marketRate').value !== null) {
                buildingInfoForm.get('marketRate').setValue(null);
            }
            if (!buildingInfoForm.get('reasons').value.includes('Section421a16')
                && buildingInfoForm.get('incomeRestricted').value !== null) {
                buildingInfoForm.get('incomeRestricted').setValue(null);
            }
        }
        if (!buildingInfoForm.get('reasons').value.includes('RegulatoryAgreement')
            && buildingInfoForm.get('regulatoryAgreementText').value !== null) {
            buildingInfoForm.get('regulatoryAgreementText').setValue(null);
        }

        if (!buildingInfoForm.get('reasons').value.includes('RegulatoryAgreement')
            && !buildingInfoForm.get('reasons').value.includes('Section243Or11244J51')
            && !buildingInfoForm.get('reasons').value.includes('Article11ofPHFL')
            && !buildingInfoForm.get('reasons').value.includes('MitchellLama')
            && !buildingInfoForm.get('reasons').value.includes('Article1415ofPHFL')
            && !buildingInfoForm.get('reasons').value.includes('Other')
            && !buildingInfoForm.get('reasons').value.includes('Section608ofPHFL')
            && buildingInfoForm.get('rentControlled').value !== null) {
            buildingInfoForm.get('rentControlled').setValue(null);
        }

        if (!buildingInfoForm.get('reasons').value.includes('Section421a16') &&
            !buildingInfoForm.get('reasons').value.includes('RegulatoryAgreement') &&
            buildingInfoForm.get('permanentExempt').value !== null) {
            buildingInfoForm.get('permanentExempt').setValue(null);
        }
    }


    // for deleting the documents on uncheck of the BUILDING reasons.
    handleAttachmentDelete(dataModel: RegistrationModel) {
        const retObj: RegistrationModel = dataModel;
        const reasonTypeMapping = {
            HPDWorkBook: 'Section421a16', RegulatoryAgreement: 'RegulatoryAgreement', GovernmentDirective: 'GovernmentDirective',
            HcrOrder: 'HcrOrder', CoverLetter: 'CoverLetter', Other: 'Other'
        };
        const matchedAttachment = [];
        dataModel.documents.forEach(element => {
            const code: string = reasonTypeMapping[element.documentType.code];
            if (retObj.registrationSummary.reasons.filter(x => x.code === code).length > 0) {
                matchedAttachment.push(element);
            } else {
                this.uploaddocumentService.delete(element.documentId);
                const deleteDocumentSubscription = this.uploaddocumentService.deleteDocument$.subscribe(value => {
                    deleteDocumentSubscription.unsubscribe();
                });
            }
        });
        dataModel.documents = matchedAttachment;
        this.dataCollectionSvc.setRegistration(dataModel);
        this.dataCollectionSvc.sync(dataModel, dataModel.transactionId);
    }

    // this code is to handle for Addon/Amendment
    UpdatehandleAttachmentDelete(dataModel: RegistrationModel, reason) {
        const reasonTypeMapping = {
            CourtOrder: 'CourtOrder', TpuDirective: 'TpuDirective', OraDirective: 'OraDirective', HpdDirective: 'HpdDirective',
            OwnerInitiated: 'OwnerInitiated', Other: 'Other'
        };
        let matchedAttachment = [];
        dataModel.documents.forEach((element, index) => {
            matchedAttachment.push(element);
            if (reasonTypeMapping[element.documentType.code]) {
                if (this.dataCollectionSvc.previousReason === element.documentType.code) {
                    matchedAttachment.splice(matchedAttachment.indexOf(element), 1);
                    this.uploaddocumentService.delete(element.documentId);
                    const deleteDocumentSubscription = this.uploaddocumentService.deleteDocument$.subscribe(value => {
                        deleteDocumentSubscription.unsubscribe();
                    });
                }
                dataModel.documents = matchedAttachment;
                this.dataCollectionSvc.sync(dataModel, null);
            }
        });
        this.dataCollectionSvc.previousReason = dataModel.registrationForRevisionReason.code;
    }
}
